import { render, staticRenderFns } from "./StudentFeeTransactionTable.vue?vue&type=template&id=369c7dec"
import script from "./StudentFeeTransactionTable.vue?vue&type=script&lang=js"
export * from "./StudentFeeTransactionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports